import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                name: null,
                guard: null,
                created_at: null,
                updated_at: null,
            };
        },

        getters: {},

        actions: {
            /**
             * @param context
             * @param data
             * @returns {Promise<any>}
             */
            hydrate(context, data) {
                return new Promise(resolve => {
                    context.commit('HYDRATE', data);

                    resolve();
                });
            },
        },

        mutations: {},
    }
);
